import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/landing/software-development/amj_back.webp";

function Amj() {
  return (
    <section
      className="mobiuscase amj_case p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="mob_icon">
              <StaticImage
                src="../../../images/landing/software-development/amj_logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={153}
                height={154}
              />
            </div>
            <h2>Fitness-Focused Mobile App Development</h2>
            <p>
              Employee wellbeing and company’s performance have a direct
              relation.
            </p>
            <Link
              to="/case-studies/amj-wellness"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              View Case Study
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Amj;
